import { SAVE_ACCOUNT_INFO } from "./accountInfoActionTypes";

export const saveAccountInfo = (accountInfo) => {
  return {
    type: SAVE_ACCOUNT_INFO,
    payload: accountInfo,
  };
};
